import {Centrifuge} from 'centrifuge'
import {defineStore} from 'pinia'
import {useChatMessagesStore} from "#imports"

export const useCentrifugoStore = defineStore('centrifugo', {
    state: () => ({
        lastMessage: {} as {
            refreshLoadedSessions?: boolean,
            refreshMissions?: boolean,
            refreshLoadedZoneData?: boolean,
            refreshZones?: number[],
            updatedZonesData?: Record<number, string>,
            updateSignalGroups?: boolean,
        },
        client: undefined as Centrifuge|undefined,
    }),
    actions: {
        async load() {
            const {user} = useAuth()
            const {$centrifuge} = useNuxtApp()
            const token = await useApi().getAuthCentrifugoToken()

            this.client = $centrifuge
            this.client.setToken(token)

            const personalChannel = 'personal:user#' + user.value?.id

            let channel = this.client?.getSubscription(personalChannel)
            if (!channel) {
                // Allocate Subscription to a channel.
                channel = this.client.newSubscription(personalChannel)
                channel.on('publication', (ctx) => {
                    console.debug('[centrifuge] Publication', ctx)

                    // Викликаємо явні оновлення сторів, це значно спрощує самі стори
                    switch (ctx.data?.type) {
                        case 'chat_channels':
                            useChatChannelsStore().handleCentrifugeNotification(ctx.data)
                            break
                        case 'chat_messages':
                            useChatMessagesStore().handleCentrifugeNotification(ctx.data)
                            break
                        case 'chat_unread_count':
                            useChatReadStatusStore().handleCentrifugeNotification(ctx.data)
                            break
                        case 'role_permissions':
                            usePermissionsStore().handleCentrifugeNotification(ctx.data)
                            break
                        case 'ew_suppression':
                            useEwSuppressionsStore().handleCentrifugeNotification(ctx.data)
                            break
                        default:
                            // Temporary trick to trigger changes always
                            ctx.data["_offset"] = ctx.offset
                            this.lastMessage = ctx.data
                            break
                    }
                })

                channel.subscribe()
            }

            this.client.connect()
        },

        $reset() {
            console.debug('[centrifuge] Reset to Centrifuge')

            const subscriptions = Object.values(this.client?.subscriptions() || []);
            for (const sub of subscriptions) {
                console.log('[centrifuge] Remove subscription', sub.channel)
                this.client?.removeSubscription(sub)
            }

            this.client?.disconnect()
            this.client?.setToken('')
            this.client = undefined
            this.lastMessage = {}
        }
    },
})